module.exports = __webpack_public_path__ + "static/media/18-selvsagt.b4f7bfe0.mp3";